<template>
  <a-modal
    ref="createModal"
    title="上传文件"
    :width="900"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirmValidate"
    :confirmLoading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="commitdata"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :rules="rules"
      class="full-width"
    >
      <a-form-model-item label="预测名称" prop="forecastName">
        <global-select
          @change="handleForecastName"
          :value.sync="commitdata.forecastName"
          selectType="select"
          requestApi="/scp/salesForecast/forecastNamePullDown"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </a-form-model-item>
      <a-form-model-item label="版本" prop="versionCode">
        <global-select
          @change="handleVersionChange"
          :value.sync="commitdata.versionCode"
          selectType="select"
          :setParams="{forecastName:commitdata.forecastName}"
          requestApi="/scp/salesForecast/versionCodePullDown"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </a-form-model-item >
      <a-form-model-item label="版本说明">
        <a-input :disabled="true" v-model="commitdata.versionDescription" />
      </a-form-model-item >
      <a-form-model-item label="事业部" prop="scpBusinessUnit">
        <global-select
          :value.sync="commitdata.scpBusinessUnit"
          selectType="select"
          requestApi="/scp/scpSopShipmentForecast/listBusiness"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </a-form-model-item >
      <a-form-model-item label="上传文件" prop="fileList">
        <a-upload :file-list="commitdata.fileList" :remove="handleRemove" :before-upload="beforeUpload">
          <a-button> <a-icon type="upload" />上传文件</a-button> <span class="col-tips">支持扩展名：.xls .xlsx...</span>
        </a-upload>
      </a-form-model-item >
    </a-form-model>
  </a-modal>
</template>

  <script>
// import { apiCreateShipmentForecast } from '@/api/scp/salesForecast/salesForecastWorkDesk'
import axios from 'axios'
import Cookies from 'js-cookie'
// 表单字段
export default {
  props: {
    uomClassOptions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      spuItemCodeSetParams: {
        forecastName: ''
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      // 表单校验
      rules: {
        forecastName: [{ required: true, message: '预测名称不能为空', trigger: 'change' }],
        versionCode: [{ required: true, message: '版本号不能为空', trigger: 'change' }],
        scpBusinessUnit: [{ required: true, message: '事业部不能为空', trigger: 'change' }],
        fileList: [{ required: true, message: '上传文件不能为空', trigger: 'change' }]
      },
      queryParams: {
        // 预测名称
        forecastName: undefined,
        startMonth: ''
      },
      commitdata: {
        forecastName: '', // 预测名称
        versionCode: '', // 版本
        versionDescription: '', // 版本描述
        scpBusinessUnit: '', // 事业部
        file: '', // 文件流
        fileList: []
      },
      inputType: 1,
      mode: ['month', 'month'],
      // 状态数据字典
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      typeList: [],
      unitOfMeasureList: []
    }
  },
  created () {},
  methods: {
    handleForecastName (val, selectList) {
      this.commitdata.versionCode = ''
      this.commitdata.versionDescription = ''
      //     debugger
      //   const filteredItem = selectList.filter(item => item.realValue === val);
      //  this.commitdata.versionDescription = filteredItem[0].bringOutDataOne
    },
    handleVersionChange (val, selectList) {
      const filteredItem = selectList.filter((item) => item.realValue === val)
      this.commitdata.versionDescription = filteredItem[0].bringOutDataOne
    },
    handleRemove (file) {
      this.commitdata.fileList = []
    },
    beforeUpload (file) {
      this.$message.success('已添加文件')
      this.commitdata.fileList = [file]
      return false
    },
    show () {
      // this.addLine()
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    confirmValidate () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirm()
        }
      })
    },
    confirm () {
          this.confirmLoading = true
          const token =
            process.env.NODE_ENV === 'development' || localStorage.getItem('isFromSystemLogin') === 'true'
              ? localStorage.getItem('token')
              : Cookies.get('Admin-Token')
          const Authorization = token ? 'Bearer ' + token : undefined
          const uploadUrl = process.env.VUE_APP_API_BASE_URL + '/scp/salesForecast/import?updateSupport=0'
          const formData = new FormData()
          formData.append('file', this.commitdata.fileList[0])
          formData.append('forecastName', this.commitdata.forecastName)
          formData.append('scpBusinessUnit', this.commitdata.scpBusinessUnit)
          formData.append('versionCode', this.commitdata.versionCode)
          formData.append('versionDescription', this.commitdata.versionDescription)
          axios
            .post(uploadUrl, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: Authorization
              }
            })
            .then((response) => {
              if (response.data.code === 200) {
              this.$message.success('上传成功')
              this.confirmLoading = false
              // 关闭本组件
              this.visible = false
              // 调用外部刷新列表方法
              this.$emit('handle-success')
              // 刷新表单
              this.reset()
              } else {
              this.$message.success(response.data.msg)
              this.confirmLoading = false
              }
            })
            .catch((error) => {
              this.$message.success(error)
              this.confirmLoading = false
            })
      // this.commitdata.dtoList = this.typeList
      // this.commitdata.type = (this.inputType === 2 ? 'Y' : 'N')
      // apiCreateShipmentForecast(this.commitdata).then(response => {
      //   if (response.code === 200) {
      //     this.$message.success('新增成功')
      //     // 关闭本组件
      //     this.visible = false
      //     // 调用外部刷新列表方法
      //     this.$emit('handle-success')
      //     // 刷新表单
      //     this.reset()
      //     this.confirmLoading = false
      //   } else {
      //     this.$message.error(response.msg)
      //     this.confirmLoading = false
      //   }
      // }).catch(e => {
      //   this.confirmLoading = false
      // })
    },
    // 表单重置
    reset () {
      this.commitdata = {
        forecastName: '', // 预测名称
        forecastMonthStart: '', // 预测起始月
        forecastMonthEnd: '', // 预测起始月
        forecastMonthTem: [], // 临时时间
        dtoList: [] // 列表数据
      }
      this.typeList = []
    }
  }
}
</script>

  <style scoped lang="less">
/deep/.ant-select {
  width: 150px;
}
/deep/.ant-input {
  width: 150px;
}
/deep/.ant-modal-body {
  height: 400px;
  overflow-y: scroll;
}
.rp-width {
  width: 200px;
}
.ip-width {
  width: 150px;
}
.full-width {
  width: 100%;
}
.col-tips {
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4470588235294118);
  line-height: 22px;
}
</style>
